/* global window */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Page from './page';
import {
  downloadRates,
  init,
  updateContractStatus,
  openDialog,
  scheduleDemo,
  downloadAllOutDated,
  downloadAllCurrent,
} from './__storeFiles__/actions';


const propTypes = {
  state: PropTypes.object,
  init: PropTypes.func,
  openDialog: PropTypes.func,
  downloadRates: PropTypes.func,
  updateContractStatus: PropTypes.func,
  scheduleDemo: PropTypes.func,
  downloadAllOutDated: PropTypes.func,
  downloadAllCurrent: PropTypes.func,
};

class AssetsLandingContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Page
        {...this.props.state}
        openDialog={this.props.openDialog}
        downloadRates={this.props.downloadRates}
        downloadAllOutDated={this.props.downloadAllOutDated}
        downloadAllCurrent={this.props.downloadAllCurrent}
        updateContractStatus={this.props.updateContractStatus}
        scheduleDemo={this.props.scheduleDemo}
      />
    );
  }
}

const mapStateToProps = state => ({ state: state.assetsLandingReducer });

const mapDispatchToProps = {
  init,
  downloadRates,
  updateContractStatus,
  openDialog,
  scheduleDemo,
  downloadAllCurrent,
  downloadAllOutDated,
};
AssetsLandingContainer.propTypes = propTypes;
AssetsLandingContainer.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssetsLandingContainer);



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/container.jsx